import WithRender from "../../templates/ui/uploadLoading.html";

export default WithRender({});
